import { render } from "./DiscountCampaignDetail.vue?vue&type=template&id=4aaa57fc"
import script from "./DiscountCampaignDetail.vue?vue&type=script&lang=js"
export * from "./DiscountCampaignDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__